/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const TransactionTypeColumnFormatter = (cellContent, row, rowIndex) => {
  const { transactionType } = row;

  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {transactionType ? transactionType : `-`}
      </div>
      <> </>
    </>
  );
};
